import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { App } from '@ui/app/App.tsx'
import '@ui/theme.css'

const container = document.getElementById('root')
if (!container) throw new Error('No hay dónde montar la aplicación.')

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
